<template>
  <v-dialog v-model="dialog" max-width="960">
    <template #activator="{on}">
        <slot name="activator" :on="on">
            <v-btn icon v-on="on">
                <v-icon><mdi-wrench></mdi-wrench></v-icon>
            </v-btn>
        </slot>
    </template>
    <v-card :disabled="loading" :loading="loading">
        <v-card-title>Mark a product as built</v-card-title>
        <v-card-text>
            <v-alert border="bottom" elevation="10" type="warning" dark>
                Don't forget to mark as built only product not used in a club to built
            </v-alert>
            <v-text-field
                v-model="quantity"
                :label="'Number of product (' + item.product.name + ') you want mark as built'"
                :hint="'Maximum: ' + maximumItemCanBeReturned "
                type="number"
                :max="maximumItemCanBeReturned"
            />
        </v-card-text>
        <v-card-actions>
            <v-btn @click="dialog=false">
                Cancel
            </v-btn>
            <v-spacer />
            <v-btn @click="doMarkAsBuilt" color="orange" dark>
                Mark as built
            </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'HandlingDialogMarkProductAsBuilt',
    props: {
        item: {
            type:Object,
            required: true
        }
    },
    data: () => ({
        dialog: false,
        quantity: null
    }),
    computed : {
        ...mapGetters('handling', ['loading']),
        maximumItemCanBeReturned () {
            return this.item.quantity-this.item.built
        }
    },
    methods: {
        ...mapActions('handling', { markProductAsBuilt : 'markProductAsBuilt'}),
        doClose(){
            this.dialog=false
            this.quantity=null
        },
        doMarkAsBuilt () {
            if(this.quantity && this.quantity <= this.maximumItemCanBeReturned) {
                this.markProductAsBuilt({
                    id: this.item.id,
                    quantityToMarkAsBuilt : this.quantity
                }).then(() => {
                    this.doClose()
                    this.$emit('update');
                })
            }
        }
    }
}
</script>

<style>

</style>